module.exports = __webpack_public_path__ + "static/banner-3-6933aafa923bd725eb4092b904bd3658.jpg";